import "./App.css";
import { AuthProvider } from "./Components/AuthContext";
import { Routes } from "react-router";
import { Route } from "react-router";
import Dashboard from "./Components/Dashboard/Dashboard";
import Discussions from "./Components/Discussions/Discussions";
import Tickets from "./Components/Tickets/Tickets";
import Lectures from "./Components/Lectures/Lectures";
import Admin from "./Components/Admin/Admin";
import Quizzes from "./Components/Quizzes/Quizzes";
function App() {
  return (
    <div className="App">
      Working on firebase authentication.....
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/discussions" element={<Discussions />} />
          <Route path="/tickets" element={<Tickets />} />
          <Route path="/lectures" element={<Lectures />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/quizzes" element={<Quizzes />} />
        </Routes>
      </AuthProvider>
    </div>
  );
}
export default App;
